var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.preguntas.length > 0
    ? _c(
        "b-container",
        { staticClass: "px-0", attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                [
                  _c("pregunta-snp", {
                    attrs: {
                      pregunta: _vm.preguntaActual,
                      index: _vm.preguntaActualIndex,
                      esMoloLectura: _vm.esMoloLectura,
                      contestacionInicial: _vm.contestacionActual,
                      comparaciones: _vm.comparaciones,
                    },
                    on: { contestar: _vm.manejaContestarPregunta },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                [
                  _c("b-pagination", {
                    attrs: {
                      size: "sm",
                      "total-rows": _vm.preguntas.length,
                      "per-page": 1,
                      align: "fill",
                      pills: "",
                      limit: "15",
                    },
                    on: { change: _vm.cambiarPagina },
                    model: {
                      value: _vm.preguntaActualIndex,
                      callback: function ($$v) {
                        _vm.preguntaActualIndex = $$v
                      },
                      expression: "preguntaActualIndex",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-right pie-tabla mt-1" }, [
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.preguntas.length) },
                }),
                _c("span", {
                  staticClass: "ml-1",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.cuestionarioSnp.cuestionario.totalDePreguntas"
                      )
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label:
                          _vm
                            .$t(
                              "apeironGwApp.cuestionarioSnp.cuestionario.comentariosGenerales"
                            )
                            .toString() + ": *",
                        "label-for": "input-comentarios-generales",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          name: "input-comentarios-generales",
                          placeholder: _vm.$t(
                            "apeironGwApp.cuestionarioSnp.cuestionario.comentariosGenerales"
                          ),
                          disabled: _vm.esMoloLectura,
                        },
                        on: { change: _vm.emiteCuestionario },
                        model: {
                          value: _vm.comentariosGenerales,
                          callback: function ($$v) {
                            _vm.comentariosGenerales = $$v
                          },
                          expression: "comentariosGenerales",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.mostrarRecomendacion
            ? _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.cuestionarioSnp.recomendacion.textoRecomendacion"
                                    ) + ": *"
                                  ),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-radio",
                                    {
                                      attrs: {
                                        name: "recomendacion",
                                        value: true,
                                        disabled: _vm.esMoloLectura,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.manejaRecomendacion()
                                        },
                                      },
                                      model: {
                                        value: _vm.recomendacion.recomienda,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.recomendacion,
                                            "recomienda",
                                            $$v
                                          )
                                        },
                                        expression: "recomendacion.recomienda",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.cuestionarioSnp.recomendacion.seRecomienda"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    {
                                      attrs: {
                                        name: "recomendacion",
                                        value: false,
                                        disabled: _vm.esMoloLectura,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.manejaRecomendacion()
                                        },
                                      },
                                      model: {
                                        value: _vm.recomendacion.recomienda,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.recomendacion,
                                            "recomienda",
                                            $$v
                                          )
                                        },
                                        expression: "recomendacion.recomienda",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.cuestionarioSnp.recomendacion.noSeRecomienda"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.cuestionarioSnp.recomendacion.aniosVigencia"
                              ) + ": *",
                            "label-for": "anios-vigencia",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "anios-vigencia", disabled: "" },
                            model: {
                              value: _vm.recomendacion.aniosVigencia,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.recomendacion,
                                  "aniosVigencia",
                                  $$v
                                )
                              },
                              expression: "recomendacion.aniosVigencia",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }